import { render, staticRenderFns } from "./junction-box-utilization-table.component.vue?vue&type=template&id=ed429656&scoped=true"
import script from "./junction-box-utilization-table.component.ts?vue&type=script&lang=ts&external"
export * from "./junction-box-utilization-table.component.ts?vue&type=script&lang=ts&external"
import style0 from "./junction-box-utilization-table.component.vue?vue&type=style&index=0&id=ed429656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed429656",
  null
  
)

export default component.exports